export const LINK_TITLE = 'Sign In';
export const TEXT = 'Already a member?';
